import { useEffect, useState } from "react";
import { loadGoogleMaps } from "../utils/loadGoogleMaps";

export function useGoogleMaps() {
  const [loaded, setLoaded] = useState(false);

  // In your useGoogleMaps hook
  const checkGoogleMapsReady = () => {
    return !!(
      window.google?.maps?.importLibrary &&
      typeof window.google.maps.importLibrary === "function"
    );
  };

  useEffect(() => {
    checkGoogleMapsReady();
    loadGoogleMaps().then(() => setLoaded(true));
  }, []);

  // console.log(loaded);

  return loaded;
}
